import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { Card, CardContent } from "../components/ui/card";
import { SpinnerGap, CheckCircle, XCircle } from "phosphor-react";

const API = process.env.REACT_APP_BACKEND_URL + "/api";

export default function UnsubscribePage() {
  const { tenantId, customerId } = useParams();
  const [loading, setLoading] = useState(true);
  const [result, setResult] = useState(null);

  useEffect(() => {
    unsubscribe();
  }, [tenantId, customerId]);

  const unsubscribe = async () => {
    try {
      const response = await fetch(`${API}/public/unsubscribe/${tenantId}/${customerId}`);
      const data = await response.json();
      setResult(data);
    } catch (error) {
      setResult({ success: false, message: "Failed to process unsubscribe request" });
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="min-h-screen bg-zinc-100 flex items-center justify-center p-4">
        <SpinnerGap size={40} className="animate-spin text-[#FF6600]" />
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-zinc-100 flex items-center justify-center p-4">
      <Card className="max-w-md w-full border-2">
        <CardContent className="p-8 text-center">
          {result?.success ? (
            <>
              <div className="w-16 h-16 rounded-full bg-emerald-100 flex items-center justify-center mx-auto mb-4">
                <CheckCircle size={32} className="text-emerald-600" />
              </div>
              <h1 className="font-heading text-xl font-bold uppercase mb-2">
                Unsubscribed
              </h1>
              <p className="text-zinc-600">
                {result.message}
              </p>
              {result.customer_name && (
                <p className="text-sm text-zinc-400 mt-4">
                  {result.customer_name}
                </p>
              )}
            </>
          ) : (
            <>
              <div className="w-16 h-16 rounded-full bg-red-100 flex items-center justify-center mx-auto mb-4">
                <XCircle size={32} className="text-red-600" />
              </div>
              <h1 className="font-heading text-xl font-bold uppercase mb-2">
                Error
              </h1>
              <p className="text-zinc-600">
                {result?.message || "Something went wrong"}
              </p>
            </>
          )}
        </CardContent>
      </Card>
      <p className="absolute bottom-4 text-xs text-zinc-400">
        Powered by Free Service Pro
      </p>
    </div>
  );
}
